import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title?: string;
  description?: string;
  image?: string;
  type?: string;
  schema?: Record<string, any>;
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title,
  description = 'Explore the world\'s largest database of animatronic figures. Learn about animatronic design, engineering, and construction techniques.',
  image = '/android-chrome-512x512.png',
  type = 'website',
  schema,
}) => {
  const { pathname } = useLocation();
  const canonicalUrl = `https://animatronicdatabase.com${pathname}`;
  const pageTitle = title || 'Animatronic Database - Discover and Learn About Animatronics';

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      
      {/* Technical Keywords */}
      <meta name="keywords" content="animatronics, robotics, mechanical engineering, control systems, pneumatics, hydraulics, electric actuators, motion control, animatronic design, theme park technology" />
      
      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="512" />
      <meta property="og:image:height" content="512" />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      
      {/* Technical Metadata */}
      <meta name="technical:framework" content="animatronics" />
      <meta name="technical:category" content="robotics" />
      <meta name="technical:application" content="theme-parks" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      <link rel="canonical" href={canonicalUrl} />
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;